import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useScroll = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
      /*eslint-disable-next-line*/
    } as Omit<ScrollToOptions, "behavior"> & { behavior: any });
  }, [pathname]);
};

export default useScroll;
